import { CropBox } from "store/types/crop";
import { BulkResizeState } from "../../../types";
import { getCropOperation } from "../../../utils/operations/getCropOperation";

interface Payload {
    payload: {
        imageId: string;
        cropBox: CropBox | null;
    };
}

export const setCropBox = (state: BulkResizeState, { payload: { cropBox, imageId } }: Payload) => {
    const image = state.images.find((image) => image.id === imageId);
    if (!image) throw new Error("image not found");
    image.crop.cropBox = cropBox;
    image.operations.push(getCropOperation(image, cropBox));

    if (!cropBox) {
        image.original.width = image.initialDimensions.width;
        image.original.height = image.initialDimensions.height;
        if (state.resizeSettings.dimensionType === "percentage") {
            const percentage = state.resizeSettings.byPercentage.percentage / 100;
            image.preview.width = Math.round(image.original.width * percentage);
            image.preview.height = Math.round(image.original.height * percentage);
            return;
        }
        if (!state.resizeSettings.isLocked) return;
        const ratio = image.original.width / image.original.height;

        if (state.resizeSettings.byDimension.width === 0 && state.resizeSettings.byDimension.height === 0) {
            image.preview.width = image.original.width;
            image.preview.height = image.original.height;
            return;
        }

        if (state.resizeSettings.byDimension.width > 0) {
            image.preview.height = Math.round(state.resizeSettings.byDimension.width / ratio);
        }

        if (state.resizeSettings.byDimension.height > 0) {
            image.preview.width = Math.round(state.resizeSettings.byDimension.height * ratio);
        }
        return;
    }

    cropBox.width = Math.round(cropBox.width);
    cropBox.height = Math.round(cropBox.height);

    image.original.width = cropBox.width;
    image.original.height = cropBox.height;

    if (state.resizeSettings.dimensionType === "percentage") {
        const percentage = state.resizeSettings.byPercentage.percentage / 100;
        image.preview.width = Math.round(image.original.width * percentage);
        image.preview.height = Math.round(image.original.height * percentage);
        return;
    }

    if (!state.resizeSettings.isLocked) return;

    if (state.resizeSettings.byDimension.width === 0 && state.resizeSettings.byDimension.height === 0) {
        image.preview.width = cropBox.width;
        image.preview.height = cropBox.height;
        return;
    }

    const ratio = cropBox.width / cropBox.height;

    if (state.resizeSettings.byDimension.width > 0) {
        image.preview.height = Math.round(state.resizeSettings.byDimension.width / ratio);
    }

    if (state.resizeSettings.byDimension.height > 0) {
        image.preview.width = Math.round(state.resizeSettings.byDimension.height * ratio);
    }
};
